import { Injectable, OnDestroy } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { interval, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class SwUpdateService implements OnDestroy {

  private unsub$ = new Subject<void>();

  constructor(private swUpdate: SwUpdate) {
    if (!this.swUpdate.isEnabled) {
      console.log('SwUpdate isEnabled: Nope 🙁');
    }
  }

  ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }

  monitorServiceWorkerUpdate(): Observable<VersionEvent> {
    return this.swUpdate.versionUpdates;
  }

  setupServiceWorker(): void {
    if (this.swUpdate.isEnabled) {
      // Service worker is enabled
      // Check for update
      interval(1000 * 60 * 0.5).pipe(
        takeUntil(this.unsub$)
      ).subscribe(() => {
        this.swUpdate.checkForUpdate();
      });
    }
  }
}
